import React, { useState } from "react";
import Dropzone from "react-dropzone";
import uploadThumb from "../../assets/upload.svg";
import axios from "axios";
import { Modalprogress } from "../Modal/Modalprogress";
import swal from "sweetalert";
import { Modalsuccessfile } from "../Modal/Modalsuccessfile";
import { getFileHash } from "../../utils/utils";
const {
  REACT_APP_API_URL,
  REACT_APP_CORD_MIDDLEWARE,
  REACT_APP_CLIENT_TOKEN,
  REACT_APP_VERIFY_TOKEN,
  REACT_APP_PROFILE_ADDRESS,
} = process.env;

const Fileinput = (props) => {
  const { actTab } = props;
  const [blockHash, setBlockHash] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [identifier, setIdentifier] = useState();
  const [loading, setLoading] = useState(false);
  const [currentHash, setCurrentHash] = useState("");
  const errdublicatecontent = document.createElement("div");

  const handleFile = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    const hash = await getFileHash(file);
    setCurrentHash(hash);
    setLoading(true);
    setTimeout(() => {
      uploadFile(hash);
    }, [6000]);
  };

  const uploadFile = async (hash) => {
    if (actTab === "create") {
      try {
        const response = await axios.post(
          `${REACT_APP_API_URL}/doc-hash/issue`,
          { fileHash: hash, address: REACT_APP_PROFILE_ADDRESS },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${REACT_APP_CLIENT_TOKEN}`,
            },
            validateStatus: (status) => status < 500,
          }
        );
        if (response.status === 200) {
          setLoading(false);
          setIdentifier(response.data.result.identifier);
          setBlockHash(response.data.result.blockHash);
          setSuccessModal(true);
        } else if (response.status === 400) {
          setLoading(false);
          const errorMessage = response.data.err.toString();
          if (errorMessage.includes("DuplicateEntryError")) {
            const match = errorMessage.match(/Identifier:\s*(stmt:[^\s"]+)/);
            const identifiererror = match ? match[1] : null;
            errdublicatecontent.innerHTML = `
                <div class='error-container'> 
                  <h5>Error: <span class='error-highlight'>Duplicate Statement Detected</span></h5>
                  <p>The statement you are trying to submit has already been anchored on the blockchain.</p> 
                  <div class='error-details'>
                    <h6>Details:</h6>
                    <ul>
                      <li><strong>Identifier:</strong> <div class='identifier'>${identifiererror}</div></li>
                      <li>Each statement must be unique.</li>
                    </ul>
                  </div>
                </div>
              `;

            swal({
              title: "Unable to anchor to chain",
              content: errdublicatecontent,
              icon: "error",
            });
          } else {
            swal({
              title: "Unable to anchor to chain",
              content: "An unknown error occurred",
              icon: "error",
            });
          }
        } else {
          setLoading(false);
          swal({
            title: "Unable to anchor to chain",
            text: response.data.error || "An unknown error occurred",
            icon: "error",
          });
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          swal({
            title: "Unable to anchor to chain",
            text: error.response.data.error || "Unable to process the request",
            icon: "error",
          });
        } else {
          swal({
            title: "Unable to anchor to chain",
            text: "Unable to process the request",
            icon: "error",
          });
        }
      }
    } else if (actTab === "verify") {
      try {
        const response = await axios.post(
          `${REACT_APP_CORD_MIDDLEWARE}/verify/document/verify`,
          { filehash: hash },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${REACT_APP_VERIFY_TOKEN}`,
            },
            validateStatus: (status) => status < 500,
          }
        );
        if (response.status === 200) {
	  console.log (response.data);
          setLoading(false);
          if (response.data?.data?.revoked) {
            swal({
              title: "Revoked",
              text: "Document is Revoked",
              icon: "error",
            });
          } else {
            setBlockHash(response.data?.data?.registryEntryId);
            setSuccessModal(true);
          }
        } else if (response.status === 400) {
          setLoading(false);
          swal({
            title: "Not anchored on chain",
            text: response.data?.message || "An error occurred",
            icon: "error",
          });
        } else {
          setLoading(false);
          swal({
            title: "Unable to process the request",
            text: response.data?.message || "An unknown error occurred",
            icon: "error",
          });
        }
      } catch (error) {
          setLoading(false);
	  console.log("detected error", error)
        if (error.response) {
          swal({
            title: "Unable to process the request",
            text: error.response.data?.message || "Unable to process the request",
            icon: "error",
          });
        } else {
          swal({
            title: "Unable to process the request",
            text: "Unable to process the request",
            icon: "error",
          });
        }
      }
    } else if (actTab === "revoke") {
      try {
        const response = await axios.post(
          `${REACT_APP_API_URL}/doc-hash/revoke`,
          { filehash: hash },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${REACT_APP_CLIENT_TOKEN}`,
            },
            validateStatus: (status) => status < 500,
          }
        );
        if (response.status === 200) {
          setLoading(false);
          setSuccessModal(true);
        } else if (response.status === 400) {
          setLoading(false);
          swal({
            title: "Unable to revoke",
            text: response.data.err || "An error occurred",
            icon: "error",
          });
        } else {
          setLoading(false);
          swal({
            title: "Unable to revoke",
            text: response.data.error || "An unknown error occurred",
            icon: "error",
          });
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          swal({
            title: "Unable to revoke",
            text: error.response.data.error || "Unable to process the request",
            icon: "error",
          });
        } else {
          swal({
            title: "Unable to revoke",
            text: "Unable to process the request",
            icon: "error",
          });
        }
      }
    }
  };

  const txtmsg =
    actTab === "create" ? (
      <>Successfully recorded on the weavenet.cord.network chain.</>
    ) : actTab === "verify" ? (
      <>Document successfully verified on weavenet.cord.network chain.</>
    ) : actTab === "revoke" ? (
      <>Document successfully revoked on weavenet.cord.network chain.</>
    ) : (
      <>Document successfully updated on weavenet.cord.network chain.</>
    );

  return (
    <div>
      <Modalprogress
        loading={loading}
        msg={
          actTab === "create"
            ? [
                "Creating digest from file...",
                `Anchoring digest to chain...<br/><span class="hash-text">File Hash: ${currentHash}</span>`,
              ]
            : actTab === "verify"
              ? [
                  "Looking for digest on the chain...",
                  `Verifying document on chain...<br/><span class="hash-text">File Hash: ${currentHash}</span>`,
                ]
              : actTab === "revoke"
                ? [
                    "Looking for digest on the chain..",
                    `Revoking document on chain...<br/><span class="hash-text">File Hash: ${currentHash}</span>`,
                  ]
                : [
                    "Creating digest from file...",
                    `Anchoring digest to chain...<br/><span class="hash-text">File Hash: ${currentHash}</span>`,
                  ]
        }
      />
      <Modalsuccessfile
        loading={successModal}
        msg={
          actTab === "create"
            ? "Anchoring Successful"
            : actTab === "verify"
              ? "Verification Successful"
              : actTab === "revoke"
                ? "Revoked Successfully"
                : "Updated Successfully"
        }
        txtmsg={txtmsg}
        Identifier={identifier}
        blockhash={blockHash}
        fileHash={currentHash} //  line to pass the file hash
        onClose={() => {
          setSuccessModal(false);
        }}
      />
      <Dropzone onDrop={(acceptedFiles) => handleFile(acceptedFiles)}>
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()} className="fileboxinput">
              <input {...getInputProps()} />

              <div className="d-flex flex-column justify-content-center align-items-center align-conent-center">
                <img
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    paddingBottom: "10px",
                  }}
                  src={uploadThumb}
                  alt={`upload icon`}
                />
                <p className="drapdroptxt">Drag & drop any file here</p>
              </div>
            </div>
          </section>
        )}
      </Dropzone>
    </div>
  );
};

export default Fileinput;
